import SimilarProducts from "./similar-products";

export default SimilarProducts;